<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.PanoniTakahiwaiMahingaMataitai"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.PanoniRuakakaEstuaryMahingaMataitai"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.PanoniAhuroaAwa"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WhakaaweWhenuaPohuenui"></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.UaPoupouwhenuaMahingaMataitai"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.UaWaipuAwa"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.RainfallWilsonsDam"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.RainfallOtaika"></app-basic-cartesian-chart>
